// PKCE (RFC 7636) helpers for the Entra public-client login flow. Entra's app registration
// is a "Mobile and desktop applications" (native) platform type — public client, no secret,
// PKCE required.

const base64UrlEncode = (bytes: ArrayBuffer | Uint8Array): string => {
  const bytesArray = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let binary = "";
  bytesArray.forEach((byteValue) => {
    binary += String.fromCharCode(byteValue);
  });
  return window.btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const generateCodeVerifier = (): string => {
  const randomBytes = new Uint8Array(32);
  window.crypto.getRandomValues(randomBytes);
  return base64UrlEncode(randomBytes);
};

export const codeChallengeFromVerifier = async (verifier: string): Promise<string> => {
  const encoder = new TextEncoder();
  const digest = await window.crypto.subtle.digest("SHA-256", encoder.encode(verifier));
  return base64UrlEncode(digest);
};
